rwgps = window.rwgps || {};

rwgps.BikeLaneControl = function(map) {
  this.map = map;
  this.controlDiv = document.createElement("DIV");
  this.controlDiv.className = 'rwgps-BikeLaneControl'
  this.controlDiv.index = 1;
  const mapType = map.gmap.getMapTypeId()
  if (!(mapType === 'roadmap' || mapType === 'satellite' || mapType === 'hybrid' || mapType === 'terrain')) {
    this.controlDiv.style.display = 'none'
  }
  var controlDiv = this.controlDiv;

  // Set CSS styles for the DIV containing the control
  // Setting padding to 5 px will offset the control
  // from the edge of the map
  controlDiv.style['padding-top'] = '6px';

  //control border
  var controlUI = document.createElement('DIV');
  controlUI.style.background = '#fff';
  controlUI.style.borderRadius = '2px';
  controlUI.style.boxShadow = '1px 1px 5px 0 rgba(0,0,0,0.25)';
  controlUI.style.cursor = 'pointer';
  controlUI.title = T.t('bike_paths_desc');
  controlUI.className = 'rwgps-controlUI'
  controlDiv.appendChild(controlUI);

  //control interior
  var controlText = document.createElement('DIV');
  controlText.style.fontFamily = '"aktiv-grotesk", "Aktiv Grotesk", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial, sans-serif';
  controlText.style.fontSize = '13px';
  controlText.style.fontSize = '13px';
  controlText.style.fontWeight = '500';
  controlText.style.padding = '7px 10px 0 10px';
  controlText.style.height = '30px';
  controlText.style.boxSizing = 'border-box';
  controlText.style.color = '#424242';
  controlText.style.userSelect = 'none';
  controlText.innerHTML = T.t('bike_paths');
  controlUI.appendChild(controlText);

  var isSet = false;
  var bikeLayer = new google.maps.BicyclingLayer();
  google.maps.event.addDomListener(controlUI, 'click', function() {
    if(isSet) {
      bikeLayer.setMap(null);
      controlUI.style.backgroundColor = "white";
    } else {
      bikeLayer.setMap(map.gmap);
      controlUI.style.backgroundColor = "#E7E7E7";
    }
    isSet = !isSet;
    map.plannerOptions.setOption("gmapsBikeOverlay", isSet);
  });
}
rwgps.BikeLaneControl.prototype.getContainingDiv = function() {
  return this.controlDiv;
}




// WEBPACK FOOTER //
// ./public/javascripts/js_maps/layer_controls.js